import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../home/sections/Footer";
import RestaurantCard from "./components/RestaurantCard";
import API_URL from "../../config/apiConfig";
import iranLocations from "../../data/iranLocations.json";
import { FiMapPin } from "react-icons/fi";
import { FiSliders } from "react-icons/fi";
import { FiGrid } from "react-icons/fi";
import { categoryTemplates } from "../../config/menuCategoryTemplates";
import OccasionFilterSection from "./components/OccasionFilterSection";
import { useClickOutside } from "../../hooks/useClickOutside";
const RestaurantsList = () => {
  const [occasionFilter, setOccasionFilter] = useState(null);
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dropdownRef = useRef(null);

  const [provinceOpen, setProvinceOpen] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [sortBy, setSortBy] = useState("popular");
  const [typeFilter, setTypeFilter] = useState("");

  const provinces = Object.keys(iranLocations).sort();
  const restaurantTypes = Object.entries(categoryTemplates).map(([key, value]) => ({
    value: key,
    label: value.label
  }))

  const [sortOpen, setSortOpen] = useState(false);

  const sortOptions = [
    { value: "nearest", label: "نزدیک‌ترین" },
    { value: "popular", label: "محبوب‌ترین" },
    { value: "rating", label: "بیشترین امتیاز" },
  ];

  const sortRef = useRef(null);
  const [typeOpen, setTypeOpen] = useState(false);
  const typeRef = useRef(null);

  useClickOutside(typeRef, () => setTypeOpen(false));
  useClickOutside(sortRef, () => setSortOpen(false));

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const res = await fetch(`${API_URL}/api/restaurants/all`);
        if (!res.ok) throw new Error("خطا در دریافت لیست رستوران‌ها");
        const data = await res.json();
        setRestaurants(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurants();
  }, []);


  useClickOutside(dropdownRef, () => setProvinceOpen(false));


  if (loading) return <p className="text-center mt-10">در حال بارگذاری...</p>;
  if (error) return <p className="text-center mt-10 text-red-500">{error}</p>;

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50">
        {/* هدر صفحه */}
        {/* Hero Section */}
        <div className="relative w-full h-[75vh] min-h-[550px] overflow-hidden flex items-center justify-center">

          {/* Background Image */}
          <img
            src="/images/hero/hero-4.jpg"
            alt="رستوران"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

          {/* Content Wrapper */}
          <div className="relative z-10 w-full max-w-6xl px-4 text-white text-center">

            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">
              رستوران‌های برتر شهر شما
            </h1>

            <p className="text-white/80 text-lg md:text-xl mb-10">
              جستجو کن، مقایسه کن و بهترین انتخاب را انجام بده
            </p>

            {/* Filter Box */}
            <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl shadow-2xl p-5">

              <div className="flex flex-col md:flex-row gap-4">

                {/* Province */}
                <div ref={dropdownRef} className="relative flex-1 text-right">
                  <div
                    onClick={() => setProvinceOpen(!provinceOpen)}
                    className="bg-white/95 backdrop-blur rounded-2xl px-6 py-4 text-gray-800 cursor-pointer flex justify-between items-center shadow-sm hover:shadow-md transition-all"
                  >
                    <span className="font-medium">
                      {selectedProvince || "انتخاب استان"}
                    </span>
                    <span className="text-gray-500 text-sm">▾</span>
                  </div>

                  {provinceOpen && (
                    <div className="absolute mt-3 w-full bg-white rounded-2xl shadow-2xl max-h-60 overflow-y-auto z-50 border border-gray-100">
                      {provinces.map((province, index) => (
                        <div
                          key={province}
                          onClick={() => {
                            setSelectedProvince(province);
                            setProvinceOpen(false);
                          }}
                          className={`
            flex items-center gap-3 px-5 py-3 cursor-pointer transition-all
            ${selectedProvince === province ? "bg-primary/10 text-primary" : "text-gray-700"}
            hover:bg-primary/10 hover:text-primary
            ${index !== provinces.length - 1 ? "border-b border-gray-100" : ""}
          `}
                        >
                          <FiMapPin
                            size={18}
                            className={`${selectedProvince === province
                              ? "text-primary"
                              : "text-gray-400"
                              } transition-colors`}
                          />

                          <span className="font-medium">{province}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Sort */}
                <div ref={sortRef} className="relative flex-1 text-right">
                  <div
                    onClick={() => setSortOpen(!sortOpen)}
                    className="w-full bg-white/95 backdrop-blur rounded-2xl 
               pr-12 pl-6 py-4 
               text-accent font-medium
               border border-primary/20
               shadow-sm hover:border-primary/40 hover:shadow-md
               focus:ring-2 focus:ring-primary/30
               transition-all duration-200
               cursor-pointer flex items-center justify-between"
                  >
                    <div className="flex items-center gap-2">
                      <FiSliders size={18} className="text-primary/70" />
                      <span>
                        {sortOptions.find((o) => o.value === sortBy)?.label || "مرتب‌سازی"}
                      </span>
                    </div>

                    <span className="text-primary/70">▾</span>
                  </div>

                  {sortOpen && (
                    <div className="absolute mt-3 w-full bg-white rounded-2xl shadow-2xl border border-primary/10 z-50 overflow-hidden">
                      {sortOptions.map((option, index) => (
                        <div
                          key={option.value}
                          onClick={() => {
                            setSortBy(option.value);
                            setSortOpen(false);
                          }}
                          className={`
            px-5 py-3 cursor-pointer transition-all
            ${sortBy === option.value
                              ? "bg-primary/10 text-primary"
                              : "text-gray-700"}
            hover:bg-primary/10 hover:text-primary
            ${index !== sortOptions.length - 1 ? "border-b border-gray-100" : ""}
          `}
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Type */}
                <div ref={typeRef} className="relative flex-1 text-right">
                  <div
                    onClick={() => setTypeOpen(!typeOpen)}
                    className="bg-white/95 backdrop-blur rounded-2xl px-6 py-4 
               border border-primary/20
               shadow-sm hover:border-primary/40 hover:shadow-md
               transition-all duration-200
               cursor-pointer flex items-center justify-between"
                  >
                    <div className="flex items-center gap-3">
                      <FiGrid size={18} className="text-primary/70" />
                      <span className="font-medium text-gray-800">
                        {restaurantTypes.find(t => t.value === typeFilter)?.label || "نوع مجموعه"}
                      </span>
                    </div>

                    <span className="text-primary/70">▾</span>
                  </div>

                  {typeOpen && (
                    <div className="absolute mt-3 w-full bg-white rounded-2xl 
                    shadow-2xl border border-primary/10 
                    max-h-60 overflow-y-auto z-50">
                      {restaurantTypes.map((type, index) => (
                        <div
                          key={type.value}
                          onClick={() => {
                            setTypeFilter(type.value);
                            setTypeOpen(false);
                          }}
                          className={`
            flex items-center gap-3 px-5 py-3 cursor-pointer transition-all
            ${typeFilter === type.value
                              ? "bg-primary/10 text-primary"
                              : "text-gray-700"}
            hover:bg-primary/10 hover:text-primary
            ${index !== restaurantTypes.length - 1 ? "border-b border-gray-100" : ""}
          `}
                        >
                          <FiGrid
                            size={16}
                            className={`${typeFilter === type.value ? "text-primary" : "text-gray-400"}`}
                          />
                          <span className="font-medium">{type.label}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Button */}
                <button className="bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-2xl font-medium shadow-lg transition-all duration-300 hover:scale-105">
                  جستجو
                </button>

              </div>

            </div>

          </div>

        </div>
        <br />
        <br />
        {/* کانتینر محتوا */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <OccasionFilterSection
            selected={occasionFilter}
            onSelect={setOccasionFilter}
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
           {restaurants
  .filter((r) =>
    occasionFilter
      ? r?.restaurantSettings?.occasions?.includes(occasionFilter)
      : true
  )
  .map((restaurant) => (
              <RestaurantCard key={restaurant._id} restaurant={restaurant} />
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RestaurantsList;
